module.exports = __webpack_public_path__ + "img/hr-heat-pipe-ending-right-1.58a28435.png";